export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fbdb49d927e46c687a0c7d5ef64e2f7fd61aec038&name=fetchTypeahead!'